import { render, staticRenderFns } from "./avatarAddEditDrawer.vue?vue&type=template&id=1f1a03ca"
import script from "./avatarAddEditDrawer.vue?vue&type=script&lang=js"
export * from "./avatarAddEditDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports